import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
// import { useQuery } from "@apollo/client";
import dayjs from "dayjs";
import { BsPrinter } from "react-icons/bs";
import { useReactToPrint } from "react-to-print";
import {
  SelectCategoryList,
  SelectGroupList,
  SelectLevelSectionList,
  SelectMaterialList,
  SelectSectionList,
  SelectSizeList,
  SelectStudent,
  SelectUnitList,
  SelectWarehouse,
} from "../Components/Include/DynamicSelect";
import KingdomOfCambodia from "../Components/Include/KingdomOfCambodia";
import BuyProductReport from "../Components/Report/BuyProductReport";
import ReportAdjustIn from "../Components/Report/ReportAdjustIn";
import ReportAdjustOut from "../Components/Report/ReportAdjustOut";
import ReportFirst from "../Components/Report/ReportFirst";
import ReportRentMaterial from "../Components/Report/ReportRentMaterial";
import ReportUniformTakeOut from "../Components/Report/ReportUniformTakeOut";
import ReportUsingMaterials from "../Components/Report/ReportUsingMaterials";
import {
  SelectDatePicker,
  SelectDateTimePicker,
} from "../Components/SelectDatePicker";

export default function Report() {
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DDT00:00:00.000"));
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DDT23:59:59.999"));

  const [warehouseVal, setWarehouseVal] = useState({ id: "", title: "" });
  const [selectValType, setSelectValType] = useState("Inventory");
  const [isHaveStock, setIsHaveStock] = useState("haveStock");
  const [reasonAdjustIn, setReasonAdjustIn] = useState("all");
  const [reasonAdjustOut, setReasonAdjustOut] = useState("all");
  const [studentVal, setStudentVal] = useState({ id: "", title: "" });

  const [sectionListVal, setSectionListVal] = useState([]);
  const [sectionListId, setSectionListId] = useState([]);

  const [levelSectionListVal, setLevelSectionListVal] = useState([]);
  const [levelSectionListId, setLevelSectionListId] = useState([]);

  const [groupListVal, setGroupListVal] = useState([]);
  const [groupListId, setGroupListId] = useState([]);

  const [categoryListVal, setCategoryListVal] = useState([]);
  const [categoryListId, setCategoryListId] = useState([]);

  const [sizeListVal, setSizeListVal] = useState([]);
  const [sizeListId, setSizeListId] = useState([]);

  const [unitListVal, setUnitListVal] = useState([]);
  const [unitListId, setUnitListId] = useState([]);

  const [materialListVal, setMaterialListVal] = useState([]);
  const [materialListId, setMaterialListId] = useState([]);

  //print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (date && endDate && date > endDate) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    if (sectionListVal?.length !== 0) {
      const newData = sectionListVal?.map((row) => row?.id);
      setSectionListId(newData);
    } else {
      setSectionListId([]);
    }
  }, [sectionListVal?.length]);

  useEffect(() => {
    if (materialListVal?.length !== 0) {
      const newData = materialListVal?.map((row) => row?.id);
      setMaterialListId(newData);
    } else {
      setMaterialListId([]);
    }
  }, [materialListVal?.length]);

  useEffect(() => {
    if (groupListVal?.length !== 0) {
      const newData = groupListVal?.map((row) => row?.id);
      setGroupListId(newData);
    } else {
      setGroupListId([]);
    }
  }, [groupListVal?.length]);

  useEffect(() => {
    if (categoryListVal?.length !== 0) {
      const newData = categoryListVal?.map((row) => row?.id);
      setCategoryListId(newData);
    } else {
      setCategoryListId([]);
    }
  }, [categoryListVal?.length]);

  useEffect(() => {
    if (sizeListVal?.length !== 0) {
      const newData = sizeListVal?.map((row) => row?.id);
      setSizeListId(newData);
    } else {
      setSizeListId([]);
    }
  }, [sizeListVal?.length]);

  useEffect(() => {
    if (unitListVal?.length !== 0) {
      const newData = unitListVal?.map((row) => row?.id);
      setUnitListId(newData);
    } else {
      setUnitListId([]);
    }
  }, [unitListVal?.length]);

  useEffect(() => {
    if (levelSectionListVal?.length !== 0) {
      const newData = levelSectionListVal?.map((row) => row?.id);
      setLevelSectionListId(newData);
    } else {
      setLevelSectionListId([]);
    }
  }, [levelSectionListVal?.length]);

  // console.log("categoryListId", categoryListId);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">របាយការណ៍</Typography>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" justifyContent="right">
          <Button className="btn-save" onClick={handlePrint}>
            <BsPrinter className="icon-save" />
            ព្រីន
          </Button>
        </Stack>
      </Stack>
      <Box sx={{ marginTop: "30px" }}>
        <Grid item container spacing={3}>
          <Grid item xs={6} sm={4} md={3} lg={3}>
            <Typography className="header-text">ជ្រើសរើស</Typography>
            <FormControl fullWidth size="small" className="search-field">
              <Select
                value={selectValType}
                onChange={(e) => {
                  setSelectValType(e.target.value);
                }}
              >
                <MenuItem value="Inventory">
                  របាយការណ៍សន្និធិប្រើប្រាស់ប្រចាំខែ
                </MenuItem>
                <MenuItem value="UsingMaterial">
                  របាយការណ៍សម្ភារៈប្រើប្រាស់ប្រចាំខែ
                </MenuItem>
                <MenuItem value="AdjustIn">
                  របាយការណ៍កែប្រែទំនិញចូលឃ្លាំង
                </MenuItem>
                <MenuItem value="AdjustOut">
                  របាយការណ៍កែប្រែទំនិញចេញឃ្លាំង
                </MenuItem>
                <MenuItem value="RentMaterial">របាយការណ៍ជួលសម្ភារៈ</MenuItem>
                <MenuItem value="UniformTakeout">
                  របាយការណ៍តាមដានសិស្សដកសម្ភារៈ
                </MenuItem>
                {/* <MenuItem value="BuyProduct">របាយការណ៍ទិញទំនិញ</MenuItem>
                <MenuItem value="ProductOut">របាយការណ៍ទំនិញចេញ</MenuItem> */}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={3}>
            <Typography className="header-text">ចាប់ពីថ្ងៃ</Typography>
            {["Inventory"]?.includes(selectValType) ? (
              <SelectDateTimePicker
                className="search-field"
                date={startDate}
                setDate={handleStartDateChange}
              />
            ) : (
              <SelectDatePicker
                className="search-field"
                date={startDate}
                setDate={handleStartDateChange}
              />
            )}
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={3}>
            <Typography className="header-text">រហូតដល់ថ្ងៃ</Typography>
            {["Inventory"]?.includes(selectValType) ? (
              <SelectDateTimePicker
                className="search-field"
                date={endDate}
                setDate={handleEndDateChange}
              />
            ) : (
              <SelectDatePicker
                className="search-field"
                date={endDate}
                setDate={handleEndDateChange}
              />
            )}
          </Grid>
        </Grid>

        <Grid item container spacing={3} marginTop={1}>
          {["RentMaterial", "UniformTakeout"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">សិស្ស</Typography>
              <SelectStudent
                isUse={null}
                className="search-field"
                selectedVal={studentVal}
                setSelectedVal={setStudentVal}
              />
            </Grid>
          )}

          {["Inventory"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">ផ្នែក</Typography>
              <SelectSectionList
                isUse={null}
                className="search-field"
                selectedVal={sectionListVal}
                setSelectedVal={setSectionListVal}
              />
            </Grid>
          )}

          {["Inventory"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">កម្រិតនៃផ្នែក</Typography>
              <SelectLevelSectionList
                isUse={null}
                className="search-field"
                selectedVal={levelSectionListVal}
                setSelectedVal={setLevelSectionListVal}
              />
            </Grid>
          )}

          {["Inventory"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">ក្រុម</Typography>
              <SelectGroupList
                isUse={null}
                className="search-field"
                selectedVal={groupListVal}
                setSelectedVal={setGroupListVal}
              />
            </Grid>
          )}

          {["Inventory"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">ទំហំ</Typography>
              <SelectSizeList
                isUse={null}
                className="search-field"
                selectedVal={sizeListVal}
                setSelectedVal={setSizeListVal}
              />
            </Grid>
          )}

          {["UsingMaterial", "BuyProduct", "ProductOut"]?.includes(
            selectValType,
          ) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">ជ្រើសរើសប្រភេទ</Typography>
              <SelectCategoryList
                className="search-field"
                setSelectedVal={setCategoryListVal}
                selectedVal={categoryListVal}
                isUse={null}
              />
            </Grid>
          )}

          <Grid item xs={6} sm={6} md={3} lg={3}>
            <Typography className="header-text">សម្ភារៈ</Typography>
            <SelectMaterialList
              isUse={null}
              className="search-field"
              selectedVal={materialListVal}
              setSelectedVal={setMaterialListVal}
            />
          </Grid>

          {["RentMaterial", "UniformTakeout"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">ខ្នាត</Typography>
              <SelectUnitList
                isUse={null}
                className="search-field"
                selectedVal={unitListVal}
                setSelectedVal={setUnitListVal}
              />
            </Grid>
          )}

          <Grid item xs={6} sm={6} md={3} lg={3}>
            <Typography className="header-text">ឃ្លាំង</Typography>
            <SelectWarehouse
              isUse={null}
              selectedVal={warehouseVal}
              setSelectedVal={setWarehouseVal}
              className="search-field"
            />
          </Grid>

          {/* <Grid item xs={6} sm={6} md={3} lg={3}>
            <Typography className="header-text">ក្រុម</Typography>
            <SelectGroup
              isUse={null}
              selectedVal={groupVal}
              setSelectedVal={setGroupVal}
              className="search-field"
            />
          </Grid> */}
          {/* <Grid item xs={6} sm={6} md={3} lg={3}>
            <Typography className="header-text">សម្ភារៈ</Typography>
            <SelectMaterial
              isUse={null}
              groupId={null}
              selectedVal={meterialVal}
              setSelectedVal={setMeterialVal}
              className="search-field"
            />
          </Grid> */}

          {["Inventory"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">ស្ថានភាពស្តុក</Typography>
              <FormControl fullWidth size="small" className="search-field">
                <Select
                  value={isHaveStock}
                  onChange={(e) => setIsHaveStock(e.target.value)}
                >
                  <MenuItem value="all">ទាំងអស់</MenuItem>
                  <MenuItem value="haveStock">មានស្តុក</MenuItem>
                  <MenuItem value="NoStock">មិនមានស្តុក</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          {["AdjustIn"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">មូលហេតុ</Typography>
              <FormControl fullWidth size="small" className="search-field">
                <Select
                  value={reasonAdjustIn}
                  onChange={(e) => setReasonAdjustIn(e.target.value)}
                >
                  <MenuItem value="all">ទាំងអស់</MenuItem>
                  <MenuItem value="free">ឥតគិតថ្លៃ</MenuItem>
                  <MenuItem value="from_use">ពីការប្រើប្រាស់</MenuItem>
                  <MenuItem value="production">ផលិត</MenuItem>
                  <MenuItem value="lack">រាប់ខ្វះ</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          {["AdjustOut"]?.includes(selectValType) && (
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Typography className="header-text">មូលហេតុ</Typography>
              <FormControl fullWidth size="small" className="search-field">
                <Select
                  value={reasonAdjustOut}
                  onChange={(e) => setReasonAdjustOut(e.target.value)}
                >
                  <MenuItem value="all">ទាំងអស់</MenuItem>
                  <MenuItem value="lose">បាត់</MenuItem>
                  <MenuItem value="broken">ខូច</MenuItem>
                  <MenuItem value="to_use">ប្រើប្រាស់</MenuItem>
                  <MenuItem value="excess">លើស</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </Box>

      <Box
        mt={2}
        p={2}
        bgcolor="#fff"
        borderRadius="8px"
        boxShadow="0 0 10px rgba(0,0,0,0.1)"
      >
        <Stack
          className="report-style"
          direction="column"
          bgcolor="#fff"
          ref={componentRef}
        >
          <KingdomOfCambodia />
          {selectValType === "Inventory" && (
            <ReportFirst
              startDate={startDate}
              endDate={endDate}
              meterialId={materialListId}
              sectionListId={sectionListId}
              levelSectionListId={levelSectionListId}
              groupId={groupListId}
              sizeListId={sizeListId}
              warehouseValId={warehouseVal?.id}
              isHaveStock={isHaveStock}
            />
          )}

          {selectValType === "UsingMaterial" && (
            <ReportUsingMaterials
              startDate={startDate}
              endDate={endDate}
              meterialId={materialListId}
              sectionListId={sectionListId}
              levelSectionListId={levelSectionListId}
              categoryId={categoryListId}
              sizeListId={sizeListId}
              warehouseValId={warehouseVal?.id}
              isHaveStock={isHaveStock}
            />
          )}

          {selectValType === "AdjustIn" && (
            <ReportAdjustIn
              startDate={startDate}
              endDate={endDate}
              meterialId={materialListId}
              warehouseValId={warehouseVal?.id}
              reason={reasonAdjustIn}
            />
          )}

          {selectValType === "AdjustOut" && (
            <ReportAdjustOut
              startDate={startDate}
              endDate={endDate}
              meterialId={materialListId}
              warehouseValId={warehouseVal?.id}
              reason={reasonAdjustOut}
            />
          )}

          {selectValType === "RentMaterial" && (
            <ReportRentMaterial
              startDate={startDate}
              endDate={endDate}
              meterialId={materialListId}
              warehouseValId={warehouseVal?.id}
              reason={reasonAdjustOut}
              studentId={studentVal?.id}
              unitListId={unitListId}
            />
          )}

          {selectValType === "UniformTakeout" && (
            <ReportUniformTakeOut
              startDate={startDate}
              endDate={endDate}
              warehouseValId={warehouseVal?.id}
              sectionListId={sectionListId}
              materialListId={materialListId}
              groupListId={groupListId}
              levelSectionListId={levelSectionListId}
              studentId={studentVal?.id}
            />
          )}

          {selectValType === "BuyProduct" && (
            <BuyProductReport
              startDate={startDate}
              endDate={endDate}
              meterialId={materialListId}
              sectionListId={sectionListId}
              levelSectionListId={levelSectionListId}
              categoryId={categoryListId}
              sizeListId={sizeListId}
              warehouseValId={warehouseVal?.id}
              isHaveStock={isHaveStock}
            />
          )}

          {/* {selectValType === "Payroll" ? (
          <PayrollReport startDate={startDate} endDate={endDate} />
        ) : (
          ""
        )}

        {selectValType === "Stock" ? (
          <StockReport
            startDate={startDate}
            endDate={endDate}
            productId={productVal?.id}
          />
        ) : (
          ""
        )}

        {selectValType === "StockOnHand" ? (
          <StockOnHandReport startDate={startDate} endDate={endDate} />
        ) : (
          ""
        )} */}
        </Stack>
      </Box>
    </div>
  );
}
